
import Vue from 'vue';

export default Vue.extend({
	name: 'CooldownLabelButton',
	props: {
		label: { type: String, required: true },
	},
});
